import {
  alpha,
  Box,
  styled,
  svgIconClasses,
  Typography,
} from '@mui/material';
import { IconButton } from 'components/ui/icons/IconButton/IconButton.js';
import type {
  FC,
  ReactNode,
} from 'react';

export const FieldsWrapper = styled(Box)(({ theme }) => ({
  padding: '20px',
  border: `1px solid ${alpha(theme.palette.common.black, 0.2)}`,
  borderTop: 0,
  marginTop: -10,
})) as FC<{ value: any; children: ReactNode }>;

export const FormHelp = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  fontSize: 12,
  whiteSpace: 'pre-line',
}));

export const StyledIconButton = styled(IconButton)({
  transform: 'rotate(180deg)',
  padding: '0 0 10px 0',
  [`& .${svgIconClasses.root}`]: {
    fontSize: '40px',
  },
});

export const Footer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '74px',
  zIndex: 1,
  boxShadow: `4px 0px 5px ${alpha(theme.palette.common.black, 0.06)}`,
  display: 'flex',
  alignItems: 'center',
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.breakpoints.values.md,
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 16,
}));
